const videoServiceTypes = [
  { id: 1, name: 'Client' },
  { id: 2, name: 'RES TV' },
  { id: 3, name: 'Proofing' },
]

export default videoServiceTypes
